export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10697.c0dc0b41.jpg";